const styles = {
  root: {
    cursor: 'pointer',
    padding: 2,
    borderRadius: 1,
    border: '1px solid #343434',
    height: '100%',
    '&:hover, &.selected': {
      backgroundColor: 'primary.main',
      '& .MuiTypography-h4': {
        color: (theme) => `${theme.palette.text.white}!important`,
      },
      '& .MuiTypography-body1': {
        color: (theme) => `${theme.palette.text.white}!important`,
      },
    },

  },

  textContainer: {
    marginBottom: 2,
  },

  title: {
  },

}

export default styles
